import { ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { ChancenEventlog } from './eventlogs/ChancenEventlog.js';

export enum RegisterEventlogType {
  PARENTS_SENDED_REGISTER_FORM = 'Eltern haben digitales Anmeldeformular abgesendet',
  PARENTS_GOT_CONFIRMATION_MAIL = 'Eltern haben Bestätigungsmail erhalten',
  PARENTS_CONFIRMED_ACCOUNT = 'Eltern haben Mail-Adresse verifiziert',
  FIRST_CONTACT_TRY_TO_PARENTS = '1. Kontaktversuch mit den Eltern',
  CONTACT_WITH_PARENTS_SUCCESSFUL = 'Kontak mit den Eltern war erfolgreich. Das Kind kann teilnehmen',
  REGISTER_DOCUMENTS_GOT_SEND = 'Versand des Dokuments zum Unterschreiben',
  REGISTER_DOCUMENTS_ARE_COMPLETE = 'Dokument zum Unterschreiben vollständig zurückerhalten',
}

@Entity()
export class RegisterEventlog extends ChancenEventlog {
  public static override _class = 'RegisterEventlog';

  @Field(() => ID, {
    default: v => v ?? '',
  })
  public studentID!: string;

  @Field(() => String, {
    default: v => v ?? '',
  })
  public type!: RegisterEventlogType;
}
